module.exports = [require("./left-sprites.js"), require("./left-libraries")];
